import React from 'react';
import tpl from '../templates/interactive.jsx';
import BaseNewCardView from '../../Cards/views/BaseNewCardView.js';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            widgets_routine_work: [],
            widgets_routine_work_loading: true
        };

        return this;
    }

    componentDidMount() {
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/openbanking/routine_work',
            widgetKey: 'widgets_routine_work'
        });
    }

    static displayName = 'OpenBanking';
}
